import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/app/contact/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/app/contact/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/app/contact/components/ServiceAreaMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6937aa485a2410001418cd35/taste_of_napoli/src/components/ui/AppIcon.tsx");
